import JSZip from 'jszip';
import SHA256 from 'crypto-js/sha256';
import FileSaver from "file-saver";
import {nanoid} from 'nanoid';
import apiService from '../../services/api.service';
import firebaseService from '../../services/firebase.service';

// action types
export const SCREENPROOF_DOWNLOAD_PDF = 'downloadScreenproofPdfFromServer';
export const DELETE_SCREENPROOF_REPORT = 'deleteScreenproofReport';
export const SCREENPROOF_CAPTURE_SCREEN = 'captureScreenshot';


// mutation types
const SET_REPORTS = 'setReports';
const SET_REPORT_FIELDS = 'saveReportFields';


const mutations = {
   [SET_REPORTS](state, reports) {
      state.reports = reports;
   },
   [SET_REPORT_FIELDS](state, fields) {
      state.reportFields = fields;
   },
};

const actions = {
   [SCREENPROOF_CAPTURE_SCREEN](context, source) {
      return new Promise((resolve, reject) => {
         apiService.setPuppeteerAsBaseUrl();
         console.log(source);
         console.log(context.getters);
         apiService.post('/capture/screen', {url: source}).then((res) => {
            context.getters.reportFields.uid = context.getters.user.uid;
            context.getters.reportFields.user = context.getters.user.name;
            context.getters.reportFields.email = context.getters.user.email;
            context.getters.reportFields.captured_file = res.data.response.url;
            context.getters.reportFields.captured_file_id = res.data.response.public_id;
            context.getters.reportFields.captured_file_hash = SHA256(`${res.data.response.url}_${nanoid()}`).toString().substr(0, 25);
            context.commit(SET_REPORT_FIELDS, context.getters.reportFields);
            resolve(res.data.response);
         }).catch((err) => {
            reject(`[createScreen] => ${err}`);
         });
      });
   },
   [SCREENPROOF_DOWNLOAD_PDF](context, id) {
      return new Promise((resolve, reject) => {

         let files = [
            {name: 'screenproof.pdf', url: `/screenproof/${id}`},
            {name: 'certtificate.pdf', url: `/certificate/${id}`}
         ];

         let zip = new JSZip();
         const promises = [];
         files.forEach((item) => {
            const promise = apiService.setPdfDownloadAsBaseUrlNew(item.url).then((arraybuffer) => {
               zip.file(item.name, arraybuffer);
            }).catch((err) => {
               reject(`[screenproofDownloadPdfFromServer] => ${err}`)
            });
            promises.push(promise);
         });

         Promise.all(promises).then(() => {
            zip.generateAsync({type: "blob"}).then(content => {
               FileSaver.saveAs(content, "file.zip");
               resolve(true);
            });
         });
      });
   },
   [DELETE_SCREENPROOF_REPORT](context, {id, captured_file_id}) {
      return new Promise((resolve, reject) => {
         firebaseService.deleteReport(id).then(() => {
            apiService.setPdfApiAsBaseUrl();
            apiService.post('/pdf/delete', {"pub_id": captured_file_id}).then(() => {
               const reports = context.getters.reports;
               context.commit(SET_REPORTS, reports.filter((el) => el.id !== id));
               resolve(true);
            }).catch((err) => {
               reject(`[deleteScreenproof] => ${err}`)
            });
         }).catch((err) => {
            reject(`[deleteReport] => ${err}`)
         });
      });
   },
};

export default {
   actions,
   mutations,
}

